<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
			<ng-container *ngIf="buttonLabel === 'Save'">{{user?.name}}</ng-container>
			<ng-container *ngIf="buttonLabel === 'Add'">New User</ng-container>
		</span>
  </div>


  <div class="buttons-block" *ngIf="buttonLabel === 'Save'">
    <button class="active-button" [class.active]="tempUser.enabled" mat-button [tabindex]="-1"
            (click)="toggleActive()">Active
    </button>
  </div>

  <div class="buttons-block" *ngIf="buttonLabel === 'Save' && this.currentUser.adminRole">
    <button class="active-button login-as-user" [class.active]="tempUser.enabled" mat-button [tabindex]="-1"
            (click)="loginAs()">Login as
    </button>
  </div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="edit-block">
  <!--	<div class="avatar-block" *ngIf="user?.bgColor">-->
  <!--		<div class="word-avatar" style.background-color="#{{user?.bgColor}}">-->
  <!--			<div class="short-name">-->
  <!--				{{user.shortCode}}-->
  <!--			</div>-->
  <!--		</div>-->
  <!--	</div>-->

  <form #userEditForm="ngForm" *ngIf="showContent">
    <div class="form-block">
      <div class="form-row">
        <p-multiSelect [ngModelOptions]="{standalone: true}" [options]="roles" [(ngModel)]="selectedRoles"
                       optionLabel="name" defaultLabel="Main Role" [filter]="false" [required]="true">
        </p-multiSelect>
      </div>
      <div class="form-row">
        <mat-form-field><input autocomplete="off" matInput placeholder="Login" [required]="true"
                               [(ngModel)]="tempUser.username" name="temporaryUserName"></mat-form-field>


        <p-colorPicker class="arrow-input" [(ngModel)]="tempUser.bgColor" class
                       [ngModelOptions]="{standalone: true}" appendTo="body">
        </p-colorPicker>
      </div>

      <div class="form-row first-last-name">
        <mat-form-field><input autocomplete="off" matInput placeholder="First Name" [required]="true"
                               [(ngModel)]="tempUser.firstName" name="temporaryFirstName"></mat-form-field>
      </div>

      <div class="form-row first-last-name">
        <mat-form-field><input autocomplete="off" matInput placeholder="Last Name" [required]="true"
                               [(ngModel)]="tempUser.lastName" name="temporaryLastName"></mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field><input autocomplete="off" matInput placeholder="Phone" type="phone"
                               [(ngModel)]="tempUser.phone" name="temporaryPhone"></mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field><input autocomplete="off" matInput placeholder="E-Mail" type="email"
                               [(ngModel)]="tempUser.email" name="temporaryEmail"></mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field> <textarea autocomplete="off" matInput placeholder="Notes" [(ngModel)]="tempUser.notes"
                                   name="temporaryNotes"></textarea>
        </mat-form-field>
      </div>
      <div class="form-row" *ngIf="buttonLabel === 'Add'">
        <mat-form-field class="dialog-password-field">
          <input autocomplete="off" matInput placeholder="New Password" type="password" [required]="true"
                 [(ngModel)]="newPassword" name="newPassword">
        </mat-form-field>
      </div>
      <div class="form-row" *ngIf="buttonLabel === 'Add'">
        <mat-form-field class="dialog-password-field">
          <input autocomplete="off" matInput placeholder="Confirm Password" type="password" [required]="true"
                 [(ngModel)]="confirmedPassword" name="confirmedPassword">
        </mat-form-field>
      </div>

    </div>

    <div class="track-time-block">
      <div class="track-date-header">
        Work Start Date
      </div>
      <div class="track-date-body">
        <p-calendar appendTo="body" [ngModelOptions]="{standalone: true}" [panelStyleClass]="'user-date-panel'"
                    [(ngModel)]="tempUser.workStartDate" (onClose)="workStartDateChanged()" [showIcon]="true"
                    [tabindex]="-1" (onShow)="blurActiveElement()">
        </p-calendar>
      </div>
    </div>

    <div class="track-time-block">
      <div class="track-date-header">
        Annual Vacation Hours
      </div>
      <div class="track-date-body">
        <p-inputNumber [(ngModel)]="tempUser.annualVacationHours" [ngModelOptions]="{standalone: true}"
                       class="vacation-input-number">
        </p-inputNumber>

        <div class="track-date-label">hours/year</div>
      </div>
    </div>

    <div class="track-time-block">
      <div class="track-date-header">
        Wages per hour & Salary
      </div>
      <div class="track-date-body">
        <p-inputNumber [(ngModel)]="tempUser.wagePerHour" [ngModelOptions]="{standalone: true}"
                       class="salary-input-number">
        </p-inputNumber>

        <div class="track-date-label">/hr</div>

        <p-inputNumber [(ngModel)]="tempUser.salary" [ngModelOptions]="{standalone: true}"
                       class="salary-input-number annual-salary">
        </p-inputNumber>

        <div class="track-date-label">/y</div>
      </div>
    </div>
    <div class="track-time-block">
      <div class="track-date-header">
        On Salary & Contractor
      </div>
      <div class="track-date-body">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempUser.onSalary">
        </p-inputSwitch>

        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempUser.isContractor">
        </p-inputSwitch>
      </div>
    </div>

    <div class="track-time-block">
      <div class="track-time-header">
        Track Work Time & Start Time
      </div>
      <div class="track-time-body">

        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempUser.trackWorkTime">
        </p-inputSwitch>

        <p-calendar appendTo="body" [disabled]="!tempUser.trackWorkTime" [ngModelOptions]="{standalone: true}"
                    hourFormat="12" [stepMinute]="15" [panelStyleClass]="'user-calendar-panel'"
                    [(ngModel)]="tempWorkTime" [timeOnly]="true"></p-calendar>
      </div>
    </div>

    <div class="track-time-block">
      <div class="track-time-header">
        Show User In Kiosk App & Allow Mobile Clock In
      </div>
      <div class="track-time-body">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempUser.showInKiosk">
        </p-inputSwitch>

        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempUser.allowMobileClockIn">
        </p-inputSwitch>
      </div>
    </div>

    <div class="track-time-block" *ngIf="buttonLabel !== 'Add'">
      <div class="track-time-body">

        <button mat-button class="reset-pswrd-btn" (click)="resetPassword()" [disabled]="resetPasswordLoading"
                tabindex="1" type="submit" [ngClass]="{'disabled-button': resetPasswordLoading}">

          <span *ngIf="!resetPasswordLoading">Reset Password</span>
          <lib-mini-progress-spinner *ngIf="resetPasswordLoading"></lib-mini-progress-spinner>
        </button>

        <button mat-button class="reset-pin-btn" (click)="resetPin()" [disabled]="resetPinLoading" tabindex="1"
                type="submit" [ngClass]="{'disabled-button': resetPinLoading}">

          <span *ngIf="!resetPinLoading">Reset Pin</span>
          <lib-mini-progress-spinner *ngIf="resetPinLoading"></lib-mini-progress-spinner>
        </button>
      </div>

      <p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="project-panel">
      </p-confirmDialog>
    </div>


    <div class="save-btn-block">

      <button mat-button class="save-btn" (click)="saveUserData()"
              [disabled]="!userEditForm.form.valid || loadingSpinner" tabindex="1" type="submit"
              [ngClass]="{'disabled-button': !userEditForm.form.valid}">

        <span *ngIf="!loadingSpinner">{{buttonLabel}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>
    </div>
  </form>

</div>
